import { useSelector } from 'react-redux';
import { isQuotaCleanerEnabledForPaid, quotaCleanerByLink } from 'reactApp/appHelpers/featuresHelpers/features/quotaCleaner';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import {
    getFeatureQuotaCleanerCloud,
    getFeatureQuotaCleanerGroups,
    getFeatureQuotaCleanerLetters,
    getFeatureQuotaCleanerMob,
    getFeatureQuotaCleanerWeb,
} from 'reactApp/modules/features/features.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { getGroupsIsLoadingError, isAllGroupsLoadedEmpty } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';

export const useShowQuotaCleaner = ({ isFromAction = false }: { isFromAction?: boolean } = { isFromAction: false }) => {
    const isMobile = useSelector(EnvironmentSelectors.isMobile);
    const isAnonymous = useSelector(UserSelectors.isAnonymous);
    const isPaid = useSelector(UserSelectors.isPaidUser);
    const isCorp = useSelector(UserSelectors.isCorpUser);
    const isBiz = useSelector(UserSelectors.isBizUser);

    const isQuotaClanerWeb = useSelector(getFeatureQuotaCleanerWeb);
    const isQuotaCleanerMob = useSelector(getFeatureQuotaCleanerMob);
    let isQuotaCleanerEnabled = !isMobile ? isQuotaClanerWeb : isQuotaCleanerMob;

    // tempexp_19209-start
    if (isPaid || isCorp || isBiz) {
        isQuotaCleanerEnabled = isQuotaCleanerEnabledForPaid || isQuotaCleanerEnabled;
    }
    // tempexp_19209-end

    if (isFromAction) {
        isQuotaCleanerEnabled = quotaCleanerByLink || isQuotaCleanerEnabled;
    }

    const isQuotaCleanerCloud = useSelector(getFeatureQuotaCleanerCloud);
    const isQuotaCleanerLetters = useSelector(getFeatureQuotaCleanerLetters);
    const quotaCleanerGroups = useSelector(getFeatureQuotaCleanerGroups);

    const isAnyGroupOn = (isQuotaCleanerCloud || isQuotaCleanerLetters) && quotaCleanerGroups.length;

    const isQuotaGroupsLoadingError = useSelector(getGroupsIsLoadingError);
    const isAllLoadedEmpty = useSelector(isAllGroupsLoadedEmpty);

    return isQuotaCleanerEnabled && isAnyGroupOn && !isQuotaGroupsLoadingError && !isAnonymous && !isAllLoadedEmpty;
};
